import React from 'react';
import { useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import getActiveCategories from './getActiveCategories.graphql';
import getSiteSettings from './getSiteSettings.graphql';
import getAllHomePageSettings from './getAllHomePageSettings.graphql';
import getAllHomePageCategorySettings from './getAllHomePageCategorySettings.graphql';
// Components
import HomeSection from '../../components/Home/HomeSection/HomeSection';
import CitySection from '../../components/Home/CitySection/CitySection';
import SafetyGrid from '../../components/Home/SafetyGrid/SafetyGrid';
import SignupGrid from '../../components/Home/SignupGrid/SignupGrid';
import HomePageCategorySection from '../../components/Home/HomePageCategorySection/HomePageCategorySection';
import CitySectionSkeleton from '../../components/Skeleton/Home/CitySectionSkeleton/CitySectionSkeleton';
import HomePageCategorySkeleton from '../../components/Skeleton/Home/HomePageCategorySkeleton/HomePageCategorySkeleton';
import { HomeProvider } from '../context/homeContext';
import useQueryResponse from '../../lib/hooks/useQueryResponse';
import s from './Home.css';

function Home() {
  const currentLocale = useSelector((state) => state?.intl?.locale);
  const siteName = useSelector(state => state?.siteSettings?.data?.siteName);

  const { data: categoriesData } = useQueryResponse({ query: getActiveCategories, ssr: false });
  const { data: siteSettingsData, loading: siteSettingsLoading } = useQueryResponse({ query: getSiteSettings, ssr: false });
  const { data: homePageSettingsData, loading: homeSettingsLoading } = useQueryResponse({ query: getAllHomePageSettings, ssr: false });
  const { data: homePageCategorySettingsData } = useQueryResponse({ query: getAllHomePageCategorySettings, ssr: false });

  let siteSettings = {}, homeSettings = {}, dynamicHomePageSettings = [];

  if (!siteSettingsLoading && !homeSettingsLoading) {
    if (siteSettingsData?.getSiteSettings?.status === 200 && siteSettingsData?.getSiteSettings?.results) {
      siteSettingsData.getSiteSettings.results.forEach((item) => {
        siteSettings[item.name] = item.value;
      });
    }

    if (homePageSettingsData?.getAllHomePageSettings?.homePageData) {
      homePageSettingsData.getAllHomePageSettings.homePageData.forEach((item) => {
        if (Array.isArray(item?.dynamicHomePageSettings)) {
          item.dynamicHomePageSettings.forEach((o) => {
            const newItem = Object.assign({}, o, { name: item?.name });
            dynamicHomePageSettings.push(newItem);
          });
        }
        homeSettings[item.name] = item.value;
      });
    }
  }

  const categoryList =
    homePageCategorySettingsData?.getAllHomePageCategorySettings?.results?.length > 0
      ? homePageCategorySettingsData.getAllHomePageCategorySettings.results
      : [];

  const activeCategories =
    categoriesData?.getActiveCategories ?? [];

  return (
    <div>
      <HomeProvider value={homeSettings}>
        <HomeSection
          currentLocale={currentLocale}
          siteName={siteName}
          dynamicHomePageSettings={dynamicHomePageSettings}
          skeletonLoading={siteSettingsLoading || homeSettingsLoading}
        />
        {activeCategories?.results?.filter(item => item?.isPopular).length > 0 ? <CitySection
          data={activeCategories}
          currentLocale={currentLocale}
          dynamicHomePageSettings={dynamicHomePageSettings}
          skeletonLoading={siteSettingsLoading || homeSettingsLoading}
        /> : <CitySectionSkeleton />}
        <SafetyGrid
          activeCategories={activeCategories}
          currentLocale={currentLocale}
          dynamicHomePageSettings={dynamicHomePageSettings}
          skeletonLoading={siteSettingsLoading || homeSettingsLoading}
        />
        <SignupGrid
          categoryList={categoryList}
          currentLocale={currentLocale}
          dynamicHomePageSettings={dynamicHomePageSettings}
          skeletonLoading={siteSettingsLoading || homeSettingsLoading}
        />
        {categoryList?.filter(item => item?.isActive).length > 0 ? <HomePageCategorySection
          data={categoryList}
          currentLocale={currentLocale}
          skeletonLoading={siteSettingsLoading || homeSettingsLoading}
        /> : <HomePageCategorySkeleton />}
      </HomeProvider>
    </div>
  );
}

export default withStyles(s)(Home);